// product Make Offer button
$(".show_makeOffer").click(function() {
    $(".makeOffer_popups").css("display","flex")
    if (typeof window.syncMakeOfferPopup === 'function') {
        window.syncMakeOfferPopup();
    }
    gtag('event', 'cs_make_offer_click', {send_to: "G-4EMR07EYMC"});
})
$(".makeOffer_popups .offer-form-container .close").click(function(){
    $(".makeOffer_popups").fadeOut(300)
})

// product addCart tips text
$(".cs_shop_click_text").click(function(){
    $(".cs_shop_click_popups").css("display","flex")
})
$(".cs_shop_click_popups section span").click(function(){
    $(".cs_shop_click_popups").fadeOut(300)
})